<!-- Modal Header with proper icon alignment -->
<div class="modal-header">
  <h3 class="modal-title">{{modalTitle}}</h3>
  <div class="header-actions">
    <i class="fa"
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
       style="margin-right: 10px; cursor: pointer;"
       (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;" id="FTC_SSEXP_CRUD_1"></i>
  </div>
</div>

<!-- Modal Body -->
<div class="modal-body" [hidden]="minimise">
  @if (showFormLoader) {
<div class="formLoader">
    <i class="fa fa-spinner fa-spin gt-refresh"></i>
  </div>
}

  @if (!showFormLoader) {
<div class="panel panel-default">
    <div class="panel-body">
      <div>
        <table>
          <tr>
            <td><p style="width:80px;text-align: right;margin-top: 10px;">Tax Year&nbsp;&nbsp;:&nbsp;</p></td>
            <td><p style="width:100px;text-align: left;margin-top: 10px;">&nbsp;&nbsp;&nbsp;&nbsp;<strong>{{ selectedTaxYear }}</strong></p></td>
            <td><p style="width:80px;text-align: center;">&nbsp;</p></td>
            <td><p style="width:100px;text-align: right;margin-top: 10px;">Filing Group&nbsp;&nbsp;&nbsp;</p></td>
            <td>
              <select id="FTC_SSEXP_CRUD_2" class="form-control" [(ngModel)]="selectedFilingGroup" style="width:350px;">
                @for (fgroup of getFilingGroupOptions(); track $index) {
<option [ngValue]="toOptionValue(fgroup.VALUE)">{{ fgroup.LABEL }}</option>
}
              </select>
            </td>
            <td><p style="width:80px;text-align: center;">&nbsp;</p></td>
            <td><p style="width:80px;text-align: right;margin-top: 10px;">GIE Name&nbsp;&nbsp;&nbsp;</p></td>
            <td>
              <select id="FTC_SSEXP_CRUD_3" class="form-control" [(ngModel)]="selectedGIECodeKey" (ngModelChange)="gieNameChange()" style="width:250px;">
                @for (gie of gieNamesDropdown; track $index) {
<option [ngValue]="toOptionValue(gie.GIE_KEY)">{{ gie.GIE_DESC }}</option>
}
              </select>
            </td>
          </tr>
        </table>
        <br>
        <table>
          <tr><td>&nbsp;</td></tr>
          <tr>
            <td><p style="width:80px;text-align: center;">&nbsp;</p></td>
            <td><p style="width:140px;text-align: center;margin-top: 5px;">{{ label1 }}</p></td>
            <td>
              @if (label1) {
<input id="FTC_SSEXP_CRUD_4" type="number" class="form-control custom-textbox"
                     [(ngModel)]="fdiiAmt" name="fdiiCode" style="height: 30px; width:250px;" />
}
            </td>
            <td><p style="width:60px;text-align: center;">&nbsp;</p></td>
            <td><p style="width:100px;text-align: center;margin-top: 5px;">{{ label2 }}</p></td>
            <td>
              @if (label2) {
<input id="FTC_SSEXP_CRUD_5" type="number" class="form-control custom-textbox"
                     [(ngModel)]="giltiAmt" name="giltiAmt" style="height: 30px; width:250px;" />
}
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
}
</div>

<!-- Footer for modal with standardized buttons -->
<div class="modal-footer" [hidden]="minimise">
  <button id="FTC_SSEXP_CRUD_6" class="save-button"
          type="button"
          [disabled]="isSaveClicked"
          (click)="save()">
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
} Save
  </button>
  <button id="FTC_SSEXP_CRUD_7" class="reset-button"
          type="button"
          (click)="reset()">Reset</button>
  @if (showDelete) {
<button id="FTC_SSEXP_CRUD_8" class="delete-button"
          type="button"
          (click)="deleteExpAnA()">Delete</button>
}
  <button id="FTC_SSEXP_CRUD_9" class="cancel-button"
          type="button"
          (click)="cancel()">Cancel</button>
</div>

<!-- Delete confirmation dialog using shared confirmation modal -->
@if (showConfirmDialog) {
<div class="modal-overlay">
  <div class="modal-dialog" (click)="$event.stopPropagation()">
    <gtw-confirmation-modal
      [config]="deleteModalConfig"
      [visible]="false"
      (confirmed)="onConfirmDelete()"
      (cancelled)="onCancelDeleteConfirm()"
      (closed)="onCancelDeleteConfirm()">
    </gtw-confirmation-modal>
  </div>
</div>
}
